import { Ability, AbilityBuilder } from '@casl/ability';

const subjectName = (item) => {
  if (!item || typeof item === 'string') {
    return item;
  }
  return item.__type;
};

export const defineRulesFor = (auth) => {
  const { can, rules } = new AbilityBuilder();
  if (auth.role !== 'driver') {
    can('view', 'tasks');
  }
  if (auth.role !== 'driver' && auth.role !== 'placer') {
    can('view', 'reports');
  }
  if (auth.role !== 'placer') {
    can('view', 'kolski-nalozi');
  }
  if (auth.role !== 'placer') {
    can('view', 'mci-cibos');
  }
  return rules;
};

export const ability = new Ability([], { subjectName });
